import {
    adios,
    Flex,
    IconChevron,
    RadioButton,
    AsButton
} from '@adserve/adserve-react-components';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { starter2Api } from '../../../constants/Endpoint';
import { CreateReservationRequest } from '../../../services/WorkflowService';
import IconReservation from '../../../svg/IconReservation';
import { ReactComponent as IconClose } from '../../../svg/icon_close.svg';

const tongueStyle = {
    position: 'fixed',
    height: 374,
    width: 171,
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
    border: '1px solid #CCCCCC',
    borderRadius: '0 0 15px 15px',
    backgroundColor: '#FFFFFF',
    marginTop: 13
};

const optionsStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500
};

const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    margin: 16
};

const buttonStyle = {
    boxSizing: 'border-box',
    height: 34,
    width: 85,
    border: '1px solid #FD9A00',
    borderRadius: 5,
    backgroundColor: '#FAA800',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 'bold',
    zIndex: 102
};

const ReservationActionCell = ({
    data,
    refreshCampaign,
    readOnly = false,
    reservationTimeValues,
    getQuotes,
    scrolling,
    workflowId
}) => {
    const [value, setValue] = useState(0);
    const [isHighlighted, setIsHightlighted] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [highlightedOption, setHighlightedOption] = useState(undefined);

    useEffect(() => {
        if (reservationTimeValues) {
            const defaultIndex = reservationTimeValues.findIndex(
                (x) => x.default
            );
            setValue(reservationTimeValues[defaultIndex]);
        }
    }, [reservationTimeValues]);

    /**
     * Event handler for a radio button check in AsDropdown
     * @param {Object} selection - The selected data
     * @param {Event} event - The event
     */
    const onCheck = (selection, event) => {
        event.stopPropagation();
        setValue(selection);
    };

    const highlightOn = () => {
        if (isHighlighted) return;
        setIsHightlighted(true);
    };
    const highlightOff = () => {
        if (!isHighlighted) return;
        setIsHightlighted(false);
    };

    const onApply = async () => {
        setShowOptions(false);
        if (value.id === 255) {
            // Release reservation
            await adios(() =>
                axios.patch(`${starter2Api}/quote/releaseRequest`, {
                    quoteId: data.id
                })
            );
            if (refreshCampaign) await refreshCampaign();
            getQuotes();
            return;
        }

        // Extend reservation
        if (workflowId) {
            CreateReservationRequest(workflowId, data.id, value.hours).then();
        } else {
            await adios(() =>
                axios.patch(`${starter2Api}/quote/reservationRequest`, {
                    quoteId: data.id,
                    hours: value.hours
                })
            );
        }

        if (refreshCampaign) await refreshCampaign();
    };

    const handleShowOptions = () => {
        setShowOptions(!showOptions);
    };

    const onOptionClick = (event, element) => {
        event.preventDefault();
        if (typeof onCheck === 'function') {
            onCheck(element, event);
        }
    };

    const onHover = (event, element) => {
        event.preventDefault();
        setHighlightedOption(element);
    };

    useEffect(() => {
        if (scrolling) {
            setShowOptions(false);
        }
    }, [scrolling]);

    return data?.extensionRequested ? (
        <span>{window.translate('Requested')}</span>
    ) : readOnly || data?.statusName !== 'Reserved' || data?.quoteType === 1 ? (
        <div />
    ) : (
        <>
            <Flex
                centre
                onMouseOver={highlightOn}
                onMouseOut={highlightOff}
                onClick={handleShowOptions}
            >
                <IconReservation
                    width={28}
                    height={28}
                    fill={isHighlighted ? 'rgb(253,154,0)' : 'rgb(65,65,65)'}
                    style={{ cursor: 'pointer', marginRight: 8 }}
                />
                <IconChevron
                    width={11}
                    height={11}
                    style={{
                        boxSizing: 'border-box',
                        pointerEvents: 'none'
                    }}
                />
            </Flex>
            {showOptions && (
                <div style={tongueStyle}>
                    <div
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <IconClose
                            width={37}
                            height={37}
                            style={{
                                boxSizing: 'border-box',
                                cursor: 'pointer'
                            }}
                            onClick={handleShowOptions}
                        />
                    </div>
                    <div style={optionsStyle}>
                        {reservationTimeValues.map((element, i) =>
                            isNaN(element?.id) ? (
                                <div
                                    key={i}
                                    style={
                                        i === 0
                                            ? { marginBottom: 8 }
                                            : {
                                                marginTop: 20,
                                                marginBottom: 4
                                            }
                                    }
                                >
                                    <span
                                        style={{
                                            marginLeft: 9
                                        }}
                                    >
                                        {element?.name}
                                    </span>
                                </div>
                            ) : (
                                <div
                                    key={i}
                                    onMouseOver={(event) =>
                                        onHover(event, element)
                                    }
                                    onMouseLeave={onHover}
                                    onClick={(event) =>
                                        onOptionClick(event, element)
                                    }
                                    style={{
                                        display: 'flex',
                                        boxSizing: 'border-box',
                                        backgroundColor:
                                            highlightedOption === element
                                                ? 'rgba(20,251,255,0.15)'
                                                : '#FFFFFF',
                                        paddingLeft: 9,
                                        cursor: 'pointer',
                                        opacity: 1,
                                        height: 25,
                                        alignItems: 'center',
                                        paddingTop: 4,
                                        paddingBottom: 4
                                    }}
                                >
                                    <RadioButton
                                        value={
                                            value?.id === element?.id ||
                                            value === element
                                        }
                                    />
                                    <span
                                        style={{
                                            marginLeft: 11,
                                            ...element?.style
                                        }}
                                    >
                                        {element?.name}
                                    </span>
                                </div>
                            )
                        )}
                    </div>
                    <div style={buttonContainerStyle}>
                        <AsButton
                            id='quotes-reservation-request-btn'
                            handleClick={onApply}
                            style={buttonStyle}
                        >
                            {window.translate('Request')}
                        </AsButton>
                    </div>
                </div>
            )}
        </>
    );
};

export default ReservationActionCell;
